module.exports = __webpack_public_path__ + "img/11.3c5629a6.png";